import { Close, Visibility } from '@mui/icons-material'
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useTranslate } from 'react-admin'
import AllBanners from './Banners/AllBanners'
import RawMarkup from './RawMarkup'

export const PreviewLanding = ({ landing }) => {
  const translate = useTranslate()
  const [openDialog, setOpenDialog] = useState(false)

  const getBanners = (banners) => {
    const bannersRelation = banners.map(elem => elem?.banner_relation);
    const bannersAux = {
      Slider: bannersRelation.filter(elem => elem?.banner_type_relation?.short_name === 'Slider'),
      ImageCards: bannersRelation.filter(elem => elem?.banner_type_relation?.short_name === 'ImageCards'),
      TextImageCards: bannersRelation.filter(elem => elem?.banner_type_relation?.short_name === 'TextImageCards'),
      ProductCards: bannersRelation.filter(elem => elem?.banner_type_relation?.short_name === 'ProductCards'),
      HorizontalCardSlider: bannersRelation.filter(elem => elem?.banner_type_relation?.short_name === 'HorizontalCardSlider'),
      FullWidth: bannersRelation.filter(elem => elem?.banner_type_relation?.short_name === 'FullWidth')
    };

    return <AllBanners banners={bannersAux} />;
  }

  return (
    <>
      <Button
        variant='contained'
        startIcon={<Visibility />}
        onClick={() => setOpenDialog(true)}
      >
        {translate('ra.action.preview')}
      </Button>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth='xl'
        fullWidth
        className='preview-landing-modal'
      >
        <DialogTitle display='flex' justifyContent='space-between'>
          {translate('ra.title.preview_landing')}
          <IconButton size='small' onClick={() => setOpenDialog(false)}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div>
            {landing?.sectors?.sort((a, b) => a.order - b.order).map((sector, i) => (
              (sector.html_content || (sector.banners && sector.banners.length > 0)) && (
                <div key={i}>
                  {sector.title && (
                    <Typography variant='h3' component='h2' style={{ fontSize: 30, margin: '15px 0', color: '#1449e4' }}>
                      {sector.title}
                      {sector.text_link && sector.link && (
                        <Button
                          variant='contained'
                          href={sector.link}
                          target='_blank'
                          style={{ marginLeft: 10, backgroundColor: '#1449e4' }}
                        >
                          {sector.text_link}
                        </Button>
                      )}
                    </Typography>
                  )}

                  {sector.html_content && (
                    <div className='se-container'>
                      <RawMarkup customClassName='sun-editor-editable' content={sector.html_content} />
                    </div>
                  )}

                  {sector.banners && sector.banners.length > 0 && getBanners(sector.banners)}
                </div>
              )
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}
